/* eslint-disable camelcase */
import { AlertaListItem } from '../utils/geral'
import { BannerTop } from './global.interface'

export type {
    LoginPageProps,
    AlertsInterface,
    ForgotPasswordProps
} from './Authentication.interface'
export type { UserLogin } from './User.interface'

export type HeaderI = {
    showAcessibility: boolean
    signupLink: string
}

export type BannerI = {
    isVisible: boolean
    url: string
    images: ImageBanner
}

export type CTAPRO = {
    isVisible: boolean
    link: string
    desktop: string
    mobile: string
}

/**
 * Home Page Props - Interface
 * IH = Interface Home
 */
export type HomePagePropsInterface = {
    banner: BannerIH
    bannerPRO: BannerIH
    bannerSazonal: BannerSazonal
    first: FirstScrollIH
    player: PlayerIH
    footer: FooterIH
    header: HeaderIH
    live: LiveIH
    maisLidas: MaisLidasIH
    opiniaoAnalise: OpinionNews
    second: SecondScrollIH
    specialCoverage: SpecialsIH
    ultimas: UltimasIH
    editableSection: EditableSectionIH
    isTrialSelfServiceUser?: boolean
}

export type CoberturasProps = {
    cta: {
        title: string
        text: string
        link: string
    }
    posts: CoberturaEspeciaisPostOrphans[]
    temas: CoberturaEspeciaisTemas[]
}

export type CoberturasEspeciaisPropsInterface = {
    footer: FooterIH
    header: HeaderIH
    coberturas: CoberturasProps
}

export type CoberturaEspeciaisTemas = {
    background_image?: string
    company_logo?: string
    company_name?: string
    description?: string
    disclaimer?: string
    id: string
    link: string
    relation_type?: string
    slug: string
    name: string
}

export type CoberturaEspeciaisPostOrphans = {
    authors: AuthorType[]
    category: string
    category_id: number
    date: string
    excerpt: string
    hat: string
    id: number
    link: string
    thumbnail: string
    title: string
}

export type SpecialsIH = {
    posts: SpecialsPostsIH[]
}

export type EditableSectionIH = {
    enabled: boolean
    title: string
    subtitle: string
    content: News[]
}

export type JOTAMetadataType = {
    name: string
    shortname: string
    sitename: string
    language: string
    url?: string
    urlLogo: string
    urlLogoPro: string
    alternativeURL: string[]
}

export type BreadCrumbItemType = {
    label: string
    slug: string
}

export enum PageTypeEnum {
    POST = 'post',
    POSTPRO = 'postpro',
    CATEGORY = 'category',
    AUTHOR = 'author',
    HOME = 'home',
    SEARCH = 'search',
    TRIAL = 'trial'
}

export type SpecialsPostsIH = {
    post_image: string
    post_title: string
    post_slug: string
    post_author: string
    post_link: string
    post_category: CategoryType[]
    defined_image: string
    defined_hat: string
    defined_title: boolean
    defined_fine_line: string
    defined_sponsored_by?: string
    defined_sponsored_type?: string
}

export type PlayerIH = {
    player_ativo: boolean
    player_chamada: string
    player_link: string
    player_chapeu: string
}

export type UltimasIH = {
    news: NewsShortMode[]
    enabled: boolean
    ctaTitle: string
    ctaDescription: string
    ctaLink: string
    btnLabel: string
}

export type MaisLidasIH = {
    news: NewsShortMode[]
    enable: boolean
    title: string
    description: string
    link: string
}

export type BannerIH = {
    enabled?: boolean
    enable: boolean
    images: ImageBanner
    url: string
    text?: string
}

export type ImageBanner = {
    desktop: ImageType
    tablet: ImageType
    mobile: ImageType
}

export type ImageType = {
    alt: string
    credit: string
    url: string
}

export type FirstScrollIH = {
    destaques: News[]
    manchete: News
}

export type ImageJU =
    | {
          desktop: string
          tabletMobile: string
          full?: string
      }
    | string
    | undefined

export type News = {
    date: string
    id: string
    image: string
    link: string
    excerpt: string
    type: 'info' | 'pro' | 'patrocinado'
    title: string
    description: string
    hat: string
    author: string | AuthorType | any
    authors: AuthorType
    category: CategoryType
    categories: CategoryType[]
    slug: string
    images?: ImageJU
    alternative: {
        title: string
        hat: string
        shortDescription: string
        thumbnail: string
    }
    inherits_from_PRO: boolean
    permalink: string
}

export type OpinionNews = {
    colunas: OpinionNewsInfos[]
    artigos: OpinionNewsInfos[]
}

export type OpinionNewsInfos = {
    id: number
    title: string
    slug: string
    thumbnail: boolean | string
    hat: string
    author: string
    category: CategoryType[]
    categories: CategoryType[]
}

export type CategoryType = {
    name: string
    slug: string
    permalink?: string
}

export type AuthorType = {
    name: string
    url: string
    bio?: string
    photo?: string
    slug?: string
}

export type FooterIH = {
    cta: string
    menu: MenuItem[]
    slogan: string
    url: string
    paginaFAQ: string
    paginaContato: string
    paginaTrabalhe: string
    paginaRedeYoutube: string
    paginaRedeFacebook: string
    paginaRedeInstagram: string
    paginaRedeLinkedIn: string
    paginaRedeTwitter: string
    paginaRedeSpotify: string
}

export type SearchIH = {
    __index: string
    _id: string
    _score: any

    _source: {
        source: {
            id: string
            type: string
            status: string
            uri: string
            published_at: string
            slug: string
            recycled: boolean
        }
        vertical: {
            id: number
            name: string
            slug: string
        }
        categories: CategoriesSearchI[]
        featured_image: {
            img_uri: string
            alt_text: string
            name: string
        }
        title: {
            hat: string
            headline: string
            subhead: string
        }
        content: {
            plain: string
        }
        authors: AuthorsSearchI[]
    }
    sort: number[]
    highlight: {
        'content.plain': string[]
    }
}

export type CategoriesSearchI = {
    id: number
    name: string
    slug: string
    leading: any
}

export type AuthorsSearchI = {
    display_name: string
    slug: string
    url: string
    name: string
}

export type MenuItem = {
    ID: number
    title: string
    url: string
    children?: MenuItem[]
    slug: string
}

export type HeaderIH = {
    assinePage: string
    enableAccessibility: boolean
    menu: MenuItem[]
    pro: CTAPROIH
    top_banner?: BannerTop | null
}

export type CTAPROIH = {
    enabled: boolean
    link: string
    textLarge: string
    textMobile: string
}

export type LiveIH = {
    is_active: boolean
    title: string
    link: string
}

export type SecondScrollIH = {
    poder: VerticalIH
    saude: VerticalIH
    tributos: VerticalIH
    trabalhista: VerticalIH
    tecnologia: VerticalIH
}

export type VerticalIH = {
    link: string
    content: News[]
}

export type ThematicSecondScrollI = {
    title: string
    subtitle: string
    destaques: News[]
}

export type EditoriaBannerI = {
    visible: boolean
    image_desktop: string
    image_tablet: string
    image_mobile: string
    alt_desktop: string
    alt_tablet: string
    alt_mobile: string
    link: string
}

export type EditoriaCTAI = {
    visible: boolean
    data: string
}

export type Pratas = {
    permalink: string
    title: string
    slug: string
    categories: CategoryType[]
    excerpt: string
    hat: string
    authors: AuthorType[]
    colunista_prata: PratasColunistas
}

export type PratasColunistas = {
    name: string
    slug: string
    description: string
    logo_url: string
}

export type NewsShortMode = {
    author: string
    authors: AuthorType[]
    authorSlug: string
    authorPhoto: string
    image: string
    images:
        | {
              desktop: string
              tabletMobile: string
              ultimasSearch: string
          }
        | string
    id: number
    title: string
    description: string
    hat: string
    type: 'coluna' | 'artigo'
    link: string
    snippet: string
    slug: string
    category: CategoryType
    categories: CategoryType[]
    inherits_from_PRO: boolean
    permalink: string
}

export type BannerSazonal = {
    enabled: boolean
    title: string
    hat: string
    description: string
    url: string
    authors: string
    images: {
        desktop: SimpleImage
        tablet: SimpleImage
        mobile: SimpleImage
    }
}

export type SimpleImage = {
    url: string
    credit: string
    alt: string
}

export type PostSponsoredCategoryInfoSponsor = {
    name: string
    disclaimer: string
    description: string
    logos: string[]
}

export type PostSponsoredCategory = {
    name: string
    slug: string
    description: string
    sponsored: PostSponsoredCategoryInfoSponsor
}

export type PostSponsoredSummary = {
    count: number
    pages: number
    category: PostSponsoredCategory
}

export type PostSponsoredDataThumbnail = {
    url: string
    alternative: string
}

export type PostSponsoredData = {
    id: number
    slug: string
    hat: string
    title: string
    category: CategoryType
    thumbnail: PostSponsoredDataThumbnail
    excerpt: string
    authors: CategoryType[]
    published_at: string
}

export type ColumnAuthorData = {
    id: number
    name: string
    slug: string
    description: string
    logo_photo: string
    frequency: string
    assinatura: string
    authors: ColumnAuthor[]
    parent_category: string
}

export type ColumnAuthor = {
    id: number
    display_name: string
    user_email: string
    user_avatar: string
}

export type Breadcrumbs = {
    id: number
    slug: string
    title: string
    children: Breadcrumbs
}

export type PostSponsored = {
    summary: PostSponsoredSummary
    posts: PostSponsoredData[]
}

export type ListComponentI = {
    content: any[]
    type: 'os' | 'wp' | 'pro-info' | 'info' | 'alerta'
    isSearchPage?: boolean
}

export type FinalUrl = {
    url: URL | null
    type: ROUTE_TYPES
    dates: DATES_TYPE
    content_type?: 'info' | 'pro-info' | null
    content_name?: string
    content_url?: string
    ID?: number
}

export enum ROUTE_TYPES {
    POST = 'post',
    PAGE = 'page',
    CATEGORY = 'category',
    TAG = 'tag',
    UNKNOWN = 'unknown'
}

export type API_RESPONSE = {
    is_redirect: boolean
    origin_url: string
    redirect_url: string
    type: 'post' | 'page' | 'category' | 'tag' | 'unknown'
    url: string
    is_external: boolean
    dates: DATES_TYPE
    content_type: 'info' | 'pro-info' | null
    content_name?: string
    content_url?: string
    ID?: number
}

export type API_RESPONSE_FROM_ID = {
    type: 'post' | 'page' | 'category' | 'tag' | 'unknown'
    permalink: string
}

export type DATES_TYPE = {
    modified: string
    published: string
    recent: string
} | null

export type CategoriesType = {
    header: HeaderIH
    footer: FooterIH
    firstSegment: {
        name: string
        slug: string
    } | null
    search: SearchIH[]
    total: any
    parent: {
        slug: string
        name: string
    }
    child: {
        slug: string
        name: string
        description: string
    }
    posts: PostSponsoredData[] | AlertaListItem[]
    totalPages: number
    currentPage: number
    sponsored: PostSponsoredCategoryInfoSponsor
    image?: { id: number; url: string; alt: string }
    isThematic: boolean
    firstScroll: FirstScrollIH | null
    secondScroll: ThematicSecondScrollI | null
    lastPostsByTags: NewsShortMode[]
    banner: EditoriaBannerI | null
    cta: EditoriaCTAI | null
    categoriaSlug: string
    postsSlug: string
}
